import React from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import ProductBadge from '../../../components/library/badges/ProductBadge';
import Lang from '../../../components/language/services/Lang';
import { Language } from '../../../components/language/services/constants';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TimeOffsetDisplay from '../../../components/library/time/TimeOffsetDisplay';
import QueueTicketStatus from './QueueTicketStatus';
import MultiYearIcon from '../../../components/library/graphics/MultiYearIcon';
import HrbTranslate from '../../../components/language/HrbTranslate';
import { QueueTableTypes } from '../enums/QueueTableTypes';
import UnassignedQueueTicketStatus from './unassigned/UnassignedQueueTicketStatus';
import InternalLink from '../../../router/InternalLink';
import { useHistory } from 'react-router-dom';
import ReassignCheckbox from './reassign/ReassignCheckbox';
import classNames from 'classnames'

const QueueTableRow = ({ ticket, isChecked, tableType, onCheckboxChange, showReassignOption, pageSelections, reassignTicketIds }) => {
    const history = useHistory();

    const handleOpenTarget = (ev) => {
        ev.preventDefault()
        ev.stopPropagation();

        history.push(`/clients/${ticket.targetId}`);
    }

    const handleOpenTicket = (ev) => {
        ev.preventDefault()
        ev.stopPropagation();
        localStorage.setItem('pageSelections', JSON.stringify(pageSelections));
        localStorage.setItem('reassignTicketIds',JSON.stringify(reassignTicketIds));

        history.push(`/tickets/${ticket.ticketId}`);
    }

    return (
        <div className={classNames('columns level div-hover', { 'adjust-width-row': showReassignOption })} onClick={handleOpenTicket}>
            {showReassignOption &&
                <div className='column is-1 adjust-width-checkbox'>
                    <ReassignCheckbox onCheckboxChange={onCheckboxChange} isChecked={isChecked} />
                </div>}
            <div className={classNames('column is-1', { 'adjust-width-messageIcon': showReassignOption })}>
                {ticket.hasUnreadMessage &&
                    <div className='indicator' />
                }
            </div>
            <div className={classNames('column is-1', { 'adjust-width-productBadge': showReassignOption })} >
                <ProductBadge productCode={ticket.ticketType} />
            </div>
            <div className='column is-4'>
                {Lang.getCurrentLanguage().toLocaleUpperCase() === Language.FRENCH ? ticket.nameFr : ticket.nameEn}
                {ticket.taxYear &&
                    <div className='queue-year-row'>
                        {ticket.taxYear}
                        {(tableType === QueueTableTypes.DEFAULT ? ticket.hasRelatedTicket : ticket.hasRelatedOpenTickets) && ticket.targetId &&
                            <div className='queue-year-row' onClick={handleOpenTarget}>
                                <div className='qyr-icon'>
                                    <MultiYearIcon />
                                </div>
                                <a>
                                    <HrbTranslate text='Tickets.Labels.MultiYear' />
                                </a>
                            </div>
                        }
                    </div>
                }
            </div>
            <div className={classNames('column ', showReassignOption ? 'is-2 adjust-chevron-position' : 'is-3')}>
                {tableType === QueueTableTypes.DEFAULT &&
                    <TimeOffsetDisplay offsetSeconds={ticket.clientLastActivity} loading={ticket == null} />
                }
                {tableType === QueueTableTypes.UNASSIGNED &&
                    <TimeOffsetDisplay offsetSeconds={ticket.clientLastModifiedOffsetSeconds} loading={ticket == null} />
                }
            </div>
            <div className={classNames('column is-2', { 'adjust-chevron-position': showReassignOption })}>
                {tableType === QueueTableTypes.DEFAULT &&
                    <QueueTicketStatus ticketStateId={ticket.ticketStateId} workflowStateIdentifier={ticket.workflowStateIdentifier} />
                }
                {tableType === QueueTableTypes.UNASSIGNED &&
                    <UnassignedQueueTicketStatus ticketStateId={ticket.ticketStateId} workflowStateIdentifier={ticket.workflowStateIdentifier} />
                }
            </div>
            <div className='column is-1'>
                <InternalLink elementId={`$link-ticket-${ticket.ticketId}`} to={`/tickets/${ticket.ticketId}`} className='is-pulled-right' useLinkBehavior>
                    <ChevronRightIcon />
                </InternalLink>
            </div>
        </div>
    );
}

QueueTableRow.propTypes = {
    queue: PropTypes.object,
    onOpenTarget: PropTypes.func.isRequired,
}

export default QueueTableRow